import React, { useEffect } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
  const { isAuthenticated, loading, refreshTokenSilently } = useAuth();
  const navigate = useNavigate();
  
  // Try to refresh the token once when this component mounts
  useEffect(() => {
    const checkAndRefreshToken = async () => {
      if (!isAuthenticated() && !loading) {
        // Token is expired, try to refresh it once
        const refreshed = await refreshTokenSilently();
        if (!refreshed) {
          // If refresh failed, navigate to login
          navigate('/login', { replace: true });
        }
      }
    };
    
    checkAndRefreshToken();
  }, []);
  
  // Show loading indicator while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  
  // Render the protected route
  return <Outlet />;
};

export default ProtectedRoute;